// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBu5wDz4PQyN6OODmnN6BGowrO9J7aZdv0",
  authDomain: "rmutto-url-shortener.firebaseapp.com",
  projectId: "rmutto-url-shortener",
  storageBucket: "rmutto-url-shortener.firebasestorage.app",
  messagingSenderId: "897835384777",
  appId: "1:897835384777:web:abe20e3a18c614fc47b218",
  measurementId: "G-JP0GCWG37F"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };